const mkCol = (key, label, { type = 'string', sorted = false, headerCls = '', cellCls = '', fixed = false } = {}) => ({
  key,
  label,
  type,
  sorted,
  fixed,
  headerClassName: headerCls,
  cellClassName: cellCls,
})

export const cuentasBaseCols = [
  mkCol('RAZON_SOCIAL', 'Razón social', {
    sorted: true,
    type: 'component',
    headerCls: 'w-[200px] min-w-[200px] max-w-[200px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[200px] min-w-[200px] max-w-[200px] shrink-0 grow-0 text-left',
  }),

  mkCol('CUIT', 'CUIT', {
    type: 'component',
    sorted: true,
    headerCls: 'w-[140px] min-w-[140px] max-w-[140px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[140px] min-w-[140px] max-w-[140px] shrink-0 grow-0 text-left',
  }),

  mkCol('CONTRATO', 'Contrato', {
    type: 'component',
    sorted: true,
    headerCls: 'w-[140px] min-w-[140px] max-w-[140px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[140px] min-w-[140px] max-w-[140px] shrink-0 grow-0 text-left',
  }),

  mkCol('MEDICO', 'Médico', {
    type: 'component',
    sorted: false,
    headerCls: 'w-[100px] min-w-[100px] max-w-[100px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[100px] min-w-[100px] max-w-[100px] shrink-0 grow-0 text-left',
  }),

  mkCol('ESTADO', 'Estado', {
    type: 'component',
    sorted: false,
    headerCls: 'w-[120px] min-w-[120px] max-w-[120px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[120px] min-w-[120px] max-w-[120px] shrink-0 grow-0 text-left',
  }),
]

export const cuentasActionCols = [
  mkCol('acciones', '', {
    type: 'component',
    headerCls: 'w-[30px] min-w-[30px] max-w-[30px] shrink-0 grow-0 text-center',
    cellCls: 'w-[30px] min-w-[30px] max-w-[30px] shrink-0 grow-0 text-center',
  }),
]

export const cuentasAllColumns = [...cuentasBaseCols, ...cuentasActionCols]
